/**
 * Find first index of object in array whose properties match the constraints
 * constraints: {key1: value1, key2: value2 ...}
 */
const findIndexOfObject = (arr: any[], constraints: any = {}): number =>
  arr.findIndex((item) => {
    return Object.keys(constraints).reduce((acc, key) => {
      return constraints[key] === item[key] ? acc : false;
    }, true);
  });

/**
 * Given a list of keys and an object, get the rest object without the keys
 */
const objectWithoutProperties = (obj: any, keys: string[]): any => {
  const target: any = {};
  for (const i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
};

/**
 * Group an array of objects by the provided properties.
 * The returned array contains on object per unique combination of properties, with the rest of the object
 * nested under a grouping key (groupName)
 * @param arr: array
 * @param keys: array of keys to group by
 * @param groupName: key name of nested group
 */
const groupBy = (arr: any[], keys: string[], groupName: string): any =>
  arr.reduce((acc: any[], item: any) => {
    // Create list of constraints { "key1": value1, "key2": value2 ...}
    const constraints = keys.reduce((acc: any, key: string) => {
      acc[key] = item[key];
      return acc;
    }, {});

    // Extract the rest of the object
    const rest = objectWithoutProperties(item, keys);

    // Find index of object in the accumulator which has key1 = value1, key2 = value2...
    const index = findIndexOfObject(acc, constraints);

    // If object does not exists, create object with key1 = value1, key2 = value2...  and rest
    // Else, concat rest to already existing group
    if (index < 0) {
      acc.push({ ...constraints, [groupName]: [rest] });
    } else {
      acc[index][groupName] = (acc[index][groupName] || []).concat(rest);
    }
    return acc;
  }, []);

export default groupBy;
